__turbopack_context__.v({
  "burst-down": "_1IHlUG_burst-down",
  "burst-left": "_1IHlUG_burst-left",
  "burst-right": "_1IHlUG_burst-right",
  "burst-up": "_1IHlUG_burst-up",
  "burstDown": "_1IHlUG_burstDown",
  "burstLeft": "_1IHlUG_burstLeft",
  "burstRight": "_1IHlUG_burstRight",
  "burstUp": "_1IHlUG_burstUp",
  "compass": "_1IHlUG_compass",
  "compassMover": "_1IHlUG_compassMover",
  "corners-a": "_1IHlUG_corners-a",
  "corners-b": "_1IHlUG_corners-b",
  "corners-c": "_1IHlUG_corners-c",
  "corners-d": "_1IHlUG_corners-d",
  "cornersA": "_1IHlUG_cornersA",
  "cornersB": "_1IHlUG_cornersB",
  "cornersC": "_1IHlUG_cornersC",
  "cornersD": "_1IHlUG_cornersD",
  "frame": "_1IHlUG_frame",
  "glow": "_1IHlUG_glow",
  "gradInner": "_1IHlUG_gradInner",
  "gradOuter": "_1IHlUG_gradOuter",
  "inheritInk": "_1IHlUG_inheritInk",
  "label": "_1IHlUG_label" + " " + __turbopack_context__.i(1931122)["shimmer"],
  "label-out": "_1IHlUG_label-out",
  "label-reveal": "_1IHlUG_label-reveal",
  "labelIn": "_1IHlUG_labelIn",
  "labelLayer": "_1IHlUG_labelLayer",
  "labelOut": "_1IHlUG_labelOut",
  "labelRow": "_1IHlUG_labelRow",
  "labelStack": "_1IHlUG_labelStack",
  "labelStatic": "_1IHlUG_labelStatic",
  "metaballs-a": "_1IHlUG_metaballs-a",
  "metaballs-b": "_1IHlUG_metaballs-b",
  "metaballsA": "_1IHlUG_metaballsA",
  "metaballsB": "_1IHlUG_metaballsB",
  "relay": "_1IHlUG_relay",
  "relay-wide-wave": "_1IHlUG_relay-wide-wave",
  "relayActivityBlock": "_1IHlUG_relayActivityBlock",
  "relayActivityBlockFourth": "_1IHlUG_relayActivityBlockFourth",
  "relayActivityBlockSecond": "_1IHlUG_relayActivityBlockSecond",
  "relayActivityBlockThird": "_1IHlUG_relayActivityBlockThird",
  "relayActivityTrack": "_1IHlUG_relayActivityTrack",
  "relayBall": "_1IHlUG_relayBall",
  "relayCapExtension": "_1IHlUG_relayCapExtension",
  "relayCapFrame": "_1IHlUG_relayCapFrame",
  "relayLeftCap": "_1IHlUG_relayLeftCap",
  "relayLeftCapFrame": "_1IHlUG_relayLeftCapFrame",
  "relayRightCap": "_1IHlUG_relayRightCap",
  "relayRightCapFrame": "_1IHlUG_relayRightCapFrame",
  "relayWideLayout": "_1IHlUG_relayWideLayout",
  "squeeze-l": "_1IHlUG_squeeze-l",
  "squeeze-r": "_1IHlUG_squeeze-r",
  "squeezeBarL": "_1IHlUG_squeezeBarL",
  "squeezeBarR": "_1IHlUG_squeezeBarR",
  "stage": "_1IHlUG_stage",
  "stageActive": "_1IHlUG_stageActive",
  "think-a": "_1IHlUG_think-a",
  "think-b": "_1IHlUG_think-b",
  "think-c": "_1IHlUG_think-c",
  "thinkA": "_1IHlUG_thinkA",
  "thinkB": "_1IHlUG_thinkB",
  "thinkC": "_1IHlUG_thinkC",
});
